import { H3 } from '../typography'
import './PageSection.css'

export function PageSection({
  title,
  actions,
  children
}: {
  title: React.ReactNode
  actions?: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <section className="page-section">
      <div className="page-section-header">
        <H3>{title}</H3>
        <div>{actions && actions}</div>
      </div>
      <div className="page-section-body">{children}</div>
    </section>
  )
}
